<template>
<div class="main users">

	<div :class="isProfile ? 'user-profile' : 'list-view'">

		<div v-if="user_type_group === 'customers'" style="grid-column:span 2;">
			<h1 style="color: #282c2e;">Customers&nbsp;
				<svg class="angle" width="14" height="21" xmlns="http://www.w3.org/2000/svg" version="1.1">
					<line x1="1" x2="12" y1="3" y2="11" stroke="black" stroke-width="3" stroke-linecap="round"/>
					<line x1="12" x2="1" y1="11" y2="19" stroke="black" stroke-width="3" stroke-linecap="round"/>
				</svg>
				Customer Accounts
			</h1>
		</div>

		<div v-else>
			<h1 v-if="isProfile">Your Account</h1>
			<h1 v-else>{{ getSiteBrand }} Users</h1>
		</div>

		<div v-if="!isProfile" class="sub-header">
			<div class="input-with-control">
				<input type="text" ref="search_term" v-model="filters.search_term" placeholder="Search..." @keyup.enter="doSearch()" v-focus>
				<div class="button action input-go" @click="doSearch()"><i class="fas fa-search"></i></div>
			</div>
			<div class="controls">
				<pagination v-if="!loading" :paging="paging" @updatePage="goToPage"></pagination>
			</div>
		</div>

		<div v-if="!isProfile" class="filters">

			<div v-if="getAdministratorFlag" style="margin: 0 0 1em 0;">
				<label>Client</label>
				<select v-model="filters.client_id" @change="getList()">
					<option value="">Select...</option>
					<option v-for="(client, index) in clients" :value="client.client_id">{{ client.company_name }} [{{ client.client_id}}]</option>
				</select>
			</div>

			<div class="title">List Only User Type...</div>
			<ul class="checkbox-group">
				<li v-for="(userType, index) in userTypes">
					<span :class="['pointer', 'far', filters.user_type_id == userType.user_type_id ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('user_type_id', userType.user_type_id)"></span>
					<label>{{ userType.description }}</label>
				</li>
			</ul>
			<div class="divider"></div>
			<ul class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.inactive ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('inactive', filters.inactive)"></span>
					<label>Inactive Users</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.force_password_change ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('force_password_change', filters.force_password_change)"></span>
					<label>Force Password Change</label>
				</li>
			</ul>

			<div class="divider"></div>
			<div :class="['button', hasFilters ? 'neutral' : 'disabled']" @click="clearFilters()">Clear Filters</div>

			<div v-if="showDetail && !isProfile && user_type_group != 'customers'" class="button action" @click="saveUser(userDetail)">Save User</div>
			<div v-if="showDetail && !isProfile && user_type_group === 'customers'" class="button action" @click="saveUser(userDetail)">Save Customer Account</div>
			
			<div v-if="showDetail && !isProfile && !$route.query.back" class="button neutral" @click="cancel()">Back to List</div>
			<div v-if="showDetail && !isProfile && $route.query.back" class="button neutral" @click="$router.push($route.query.back)">Back to {{ $route.query.label || 'Previous' }}</div>

			<router-link v-if="!showDetail && user_type_group != 'customers'" tag="div" :to="'/users/' + (user_type_group ? 'user-type-group/' + user_type_group + '/' : '') + (user_type_id ? 'user-type/' + user_type_id + '/' : '') +  'user/new'" :class="['button', user_id == 'new' ? 'disabled' : 'action']">Create A User</router-link>
			<router-link v-if="!showDetail && user_type_group === 'customers'" tag="div" :to="'/users/' + (user_type_group ? 'user-type-group/' + user_type_group + '/' : '') + (user_type_id ? 'user-type/' + user_type_id + '/' : '') +  'user/new'" :class="['button', user_id == 'new' ? 'disabled' : 'action']">Create A Customer Account</router-link>

			<div v-if="!getAdministratorFlag && getUser.administrator_flag && getUser.user_type_code.indexOf('FFL_OFFICE') < 0 && user_type_group != 'customers'">
				<div class="divider"></div>
				<div v-if="userDetail.user_type_code == 'AUDITOR'" class="note">Auditors are limited users with access to log books only. User Permissions not available.</div>
				<div v-else :class="['button', user_id == 'new' ? 'disabled' : 'neutral']" style="margin: 1em 0 0 0;" @click="goUserPermissions()">User Permissions</div>
			</div>
		</div>

		<div v-if="!showDetail" class="list">
			<table v-if="list.length > 0" class="data-list" cellpadding="0" cellspacing="0">
				<thead>
					<tr>
						<th v-if="getAdministratorFlag" class="list left">Client</th>
						<th class="list left">Username</th>
						<th class="list left">First Name</th>
						<th class="list left">Last Name</th>
						<th class="list left">User Type</th>
						<th class="list left">Admin</th>
						<th class="list left">PIN</th>
						<th class="lis left">Last Login</th>
					</tr>
				</thead>
				<tbody>
					<router-link tag="tr" :to="'/users/' + (user_type_group ? 'user-type-group/' + user_type_group + '/' : '') + (user_type_id ? 'user-type/' + user_type_id + '/' : '') + 'user/' + item.user_id" v-for="item in list" class="clickable-list-item" :key="item.user_id">
						<td v-if="getAdministratorFlag" class="list left">{{ item.client_name }} [{{ item.client_id }}]</td>
						<td class="list left">{{ item.user_name }}</td>
						<td class="list left">{{ item.first_name }}</td>
						<td class="list left">{{ item.last_name }}</td>
						<td class="list left">{{ item.user_type_code.capitalizeWords() }}</td>
						<td class="list left">
							<i v-if="item.administrator_flag > 0" data-v-2104644f="" class="fa fa-check" aria-hidden="true"></i>
						</td>
						<td class="list left">{{ item.user_type_code == 'POS_CASHIER' ? item.pin : '' }}</td>
						<td class="list left">{{ item.last_login }}</td>
					</router-link>
				</tbody>
			</table>

			<div v-else class="empty-list">This list is empty</div>
		</div>

		<div v-if="showDetail" class="three-one-columns" :style="isProfile ? 'padding: 2em;' : 'padding: 0 0 0 1em;'">

			<div class="section">
				<h2 v-if="user_type_group != 'customers'">User Profile</h2>
				<h2 v-else>Customer Profile</h2>
				<contact-detail-form :clientId="userDetail.client_id" :contact="userDetail" :addressNotRequired="true" :emailRequired="true" :hideControls="true" :hideFFLInputs="true" :hideNotes="true" @update="updateContact" :ref="'conatct_detail_' + userDetail.user_id" />
				<div v-if="isProfile" class="controls with-border">
					<div :class="['button', 'spaced', saving ? 'disabled' : 'action']" @click="saveUser(userDetail)">Save Profile</div>
				</div>
			</div>

			<div class="section">
				<h2>Security</h2>
				<user-inputs :user="userDetail" :userTypes="userTypes" />
			</div>
		</div>

		<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	</div>

</div>
</template>

<script>
import ContactDetailForm from '@/components/ContactDetailForm'
import UserInputs from '@/components/UserInputs'
import LabelRequired from '@/components/LabelRequired.vue'
import Message from '@/components/Message.vue'
import { runInThisContext } from 'vm'
export default {
	name: 'users',
	props: ['user_type_id', 'user_id', 'user_type_group'],
    components: {
        'contact-detail-form': ContactDetailForm,
        'user-inputs': UserInputs,
        'label-required': LabelRequired,
        'message': Message
    },
	data() {
		return {
			clientId: this.getClientId,
			loading: false,
			message: '',
			saving: false,
			messageStatus: '',
			messageTimeout: 0,
			showFilters: true,
			isProfile: false,
			userTypes: [],
			filters: {
				search_term: '',
				user_type_id: '',
				manager_flag: 0,
				inactive: false,
				force_password_change: false
			},
			paging: {},
			list: [],
			userDetail: {},
			clients: [],
			showDetail: false,
			showToolTip: false,
			toolTipMessage: ''
		}
	},
	created() {
		if (this.$route.path.indexOf('profile') > -1) {
			this.isProfile = true
			this.getDetail(this.getUser.user_name)
		} else {
			this.isProfile = false
			this.clearFilters()
			this.getUserTypes()
			if (this.user_id) {
				if (this.user_id == 'new') {
					this.newUser()
				} else {
					this.getDetail(this.user_id)
				}
			} else {
				this.getList()
				if (this.getAdministratorFlag) {
					this.getListClients()
				}
			}
		}
	},
	computed: {
		hasFilters() {
			for (const [key, value] of Object.entries(this.filters)) {
				if (['search_term', 'user_type_id', 'client_id', 'inactive', 'force_password_change'].includes(key) && value) {
					return true
				}
				if (this.filters.page > 1) {
					return true
				}
			}
			return false
		},
		managerUserTypes() {
			return this.userTypes.filter(user_type => user_type.manager_flag == 1);
		}
	},
	watch: {
		user_type_group: function() {
			// if we were already in users, and they clicked their User Profile, don't reset!
			if (this.$route.path.indexOf('profile') < 0) {
				this.clearFilters()
				this.getUserTypes()
				this.getList()
			}
		},
		user_id: function() {
			if (this.user_id) {
				if (this.user_id == 'new') {
					this.newUser()
				} else {
					this.getDetail(this.user_id)
				}
			}
		},
		'$route'(to, from) {
			if (to.params.user_type_id !== from.params.user_type_id) {
				this.clearFilters();
			}
		}
	},
	methods: {
		getListClients() {
			this.apiCall({ destination: 'get_list_clients_full_list' }).then(obj => {
				this.clients = obj.clients
			}).catch(err => {
				console.log(err)
			})
		},
        getUserTypes() {
			this.apiCall({ destination: 'get_list_user_types', data: { manager_flag: this.filters.manager_flag } }).then(obj => {
                this.userTypes = obj.user_types
            }).catch(err => {
                console.log(err);
            })
		},
		getList() {
			if (this.loading) { return }
			if (this.user_id) { this.cancel() }
			this.loading = true
			this.showDetail = false
			this.apiCall({ destination: 'get_list_users', data: this.filters }).then(obj => {
				this.loading = false
				this.clientId = obj.client_id
				if (obj.status == 'success') {
					this.list = obj.users
					this.paging = obj.paging
				}
			}).catch(err => {
				console.log(err)
			})
		},
		userTypeCode(userTypeId) {
			if (this.isProfile) {
				return this.getUser.user_type_code
			}
			if (userTypeId == 'store_administrator') {
				return 'MANAGER'
			}
			for (let i = 0; i < this.userTypes.length; i++) {
				if (this.userTypes[i].user_type_id == userTypeId) {
					return this.userTypes[i].user_type_code
				}
			}
		},
		toggleFilter(which, value) {
			if (which == 'inactive' || which == 'force_password_change') {
				this.filters[which] = !this.filters[which]
			} else {
				let goRoute = ''
				if (this.filters[which] == value) {
					this.filters[which] = ''
					goRoute = '/users' + (this.user_type_group ? '/user-type-group/' + this.user_type_group : '')
				} else {
					this.filters[which] = value
					goRoute = '/users/' + (this.user_type_group ? 'user-type-group/' + this.user_type_group + '/' : '') + 'user-type/' + this.filters[which]
				}
				if (this.$route.path != goRoute) {
					this.$router.push(goRoute)
				}
			}
			this.getList()
		},
		clearFilters() {
			this.filters = {
				page: 1,
				search_term: '',
				manager_flag: this.$route.params.user_type_group !== 'customers' ? 1 : 0,
				inactive: false,
				force_password_change: false
			}
			if (this.getAdministratorFlag) {
				this.filters.client_id = ''
			}
			this.filters.user_type_id = this.user_type_id || '',
			this.getList()
		},
		doSearch() {
			if (this.filters.search_term) {
				this.getList()
			}
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		getDetail(item) {
			let userId = item.user_id || item
			this.apiCall({ destination: 'get_item_user', data: { user_id: userId } }).then(obj => {
				if (obj.status == 'success') {
					this.userDetail = obj.user_detail
					this.clientId = obj.client_id // normally set in getList, but can come directly to getDetail
					this.showDetail = true
				}
			}).catch(err => {
				console.log(err)
			})
		},
		updateContact(editedUserDetail) {
			// don't overwrite user-specific info
			let currentUserDetail = {
				user_type_code: this.userDetail.user_type_code,
				user_name: this.userDetail.user_name,
				new_password: this.userDetail.new_password,
				pos_manager_code: this.userDetail.pos_manager_code,
				pin: this.userDetail.pin,
				user_type_id: this.userDetail.user_type_id,
				administrator_flag: this.userDetail.administrator_flag,
				client_id: this.userDetail.client_id
			}
			this.userDetail = {
				...editedUserDetail,
				...currentUserDetail
			}
		},
		newUser() {
			this.userDetail = {
				user_type_code: '',
				user_name: '',
				new_password: '',
				pos_manager_code: '',
				pin: '',
				user_type_id: '',
				administrator_flag: ''
			}
			if (this.$route.query.contact_id) {
				this.apiCall({ destination: 'get_item_contact', data: { contact_id: this.$route.query.contact_id } }).then(obj => {
					if (obj.status == 'success') {
						this.userDetail = obj.contact
						this.clientId = obj.client_id
					}
				}).catch(err => {
					console.log(err)
				})
			} else {
				if (this.getAdministratorFlag) {
					this.userDetail.client_id = this.filters.client_id
				} else {
					this.userDetail.client_id = this.clientId
				}
			}
			this.showDetail = true
		},
		saveUser(edited_userDetail) {
			if (this.saving) { return }
			this.message = ''
			this.messageStatus = ''
			this.messageTimeout = 0
			if (!edited_userDetail.email_address) {
				this.message = "Email address is required"
				this.messageStatus = 'invalid'
				return false
			}
			if (!edited_userDetail.user_name) {
				this.message = "User name is required"
				this.messageStatus = 'invalid'
				return false
			}
			if (!edited_userDetail.user_id && !edited_userDetail.new_password) {
				this.message = "Password is required for new users"
				this.messageStatus = 'invalid'
				return false
			}
			if (!edited_userDetail.user_type_id) {
				this.message = "User type is required"
				this.messageStatus = 'invalid'
				return false
			}
			if (this.getAdministratorFlag) {
				edited_userDetail.client_id = this.userDetail.client_id
			} else {
				edited_userDetail.client_id = this.clientId
			}
			if (!this.isProfile && !edited_userDetail.client_id) {
				this.message = "Client is missing"
				this.messageStatus = 'invalid'
				return false
			}
			this.saving = true
			this.messageTimeout = 3
			this.message = "Saving " + (this.isProfile ? 'Profile' : 'User')
			this.messageStatus = 'waiting'
			this.apiCall({ destination: 'save_item_contact', data: edited_userDetail }).then(obj => {
				if (obj.status == 'success') {
					edited_userDetail.contact_id = obj.contact_id
					edited_userDetail.user_name = this.userDetail.user_name
					edited_userDetail.new_password = this.userDetail.new_password
					edited_userDetail.pin = edited_userDetail.user_type_code == 'POS_CASHIER' ? this.userDetail.pin : ''
					edited_userDetail.pos_manager_code = this.userDetail.pos_manager_code
					edited_userDetail.force_password_change = this.userDetail.force_password_change
					edited_userDetail.inactive = this.userDetail.inactive
					// only MANAGERs can also be store adminsitrators
					if (edited_userDetail.user_type_code.indexOf('MANAGER') > -1) {
						edited_userDetail.administrator_flag = this.userDetail.administrator_flag
					} else {
						edited_userDetail.administrator_flag = 0
					}
					this.apiCall({ destination: 'save_item_user', data: edited_userDetail }).then(obj => {
						this.saving = false
						this.messageTimeout = 3
						this.messageStatus = obj.status
						if (obj.status == 'success') {
							this.message = (this.isProfile ? 'Profile' : 'User') + ' saved!'
							if (obj.user_id != this.userDetail.user_id) {
								let refreshRoute = '/users' + (this.user_type_group ? '/user-type-group/' + this.user_type_group : '') + (this.user_type_id ? '/user-type/' + this.user_type_id : '') + '/user/' + obj.user_id
								this.$router.push(refreshRoute)
							}
						} else {
							this.message = obj.message
						}
					}).catch(err => {
						console.log(err)
					})
				} else {
					this.saving = false
					this.messageStatus = obj.status
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		cancel() {
			this.userDetail = {}
			this.showDetail = false
			let backRoute = '/users' + (this.user_type_group ? '/user-type-group/' + this.user_type_group : '') + (this.user_type_id ? '/user-type/' + this.user_type_id : '')
			this.$router.push(backRoute)
		},
		goUserPermissions() {
			if (this.user_id == 'new') {
				return
			}
			this.$router.push('/user-permissions' + (this.user_id ? '/' + this.user_id : ''))
		}
	}
}
</script>
